'use client'

import { useEffect, useRef } from 'react'
import { useI18n } from './i18n'

export default function FooterMarqueeTail({ renderManaged = false, text = '' }) {
  const { t } = useI18n()
  const marqueeText = String(text || '').trim() || t('marquee')
  const marqueeRef = useRef(null)

  useEffect(() => {
    const el = marqueeRef.current
    if (!el || el.dataset.duped === '1') return
    el.innerHTML += el.innerHTML
    el.dataset.duped = '1'
  }, [])

  const managedProps = renderManaged ? { 'data-ql7-render-managed': '1' } : undefined

  return (
    <section
      className="marquee-wrap no-gutters"
      aria-hidden="true"
      data-ql7-visual-scope="panel"
      {...managedProps}
    >
      <div className="marquee" ref={marqueeRef}>
        <span>{marqueeText}</span>
        <span>{marqueeText}</span>
        <span>{marqueeText}</span>
        <span>{marqueeText}</span>
      </div>
    </section>
  )
}
